module.exports = __webpack_public_path__ + "img/cloud-rain-2.68a9c506.svg";